import * as Yup from 'yup';
import * as moment from 'moment';
import { BIDFORMAT } from '../utils/dateOfBirthValidation';

export function getInitialValues(response) {

    let plusTwo = moment(new Date().setDate(new Date(response.deliveryDate).getDate() + 2))
    let dateSet = new Date(plusTwo)
    let dateArr = []
    if (response && response.order && response.order.defaultProfile && response.order.defaultProfile.dayOfWeeks) {
        if (response.order.defaultProfile.dayOfWeeks.length !== 0) {
            for (let i = 0; i < response.order.defaultProfile.dayOfWeeks.length; i++) {
                let weekDays = [
                    'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'
                ];

                let curDate = new Date();
                let to = curDate.setDate(curDate.getDate() + 7);
                for (let j = 0; j < weekDays.length; j++) {
                    if (weekDays[j] === response.order.defaultProfile.dayOfWeeks[i]) {
                        // let findDate = curDate.setDate(curDate.getDate() + j);
                        for (let k = new Date(); k < new Date(to); k.setDate(k.getDate() + 1)) {
                            let findDay = new Date(k).getDay()

                            if (findDay === 0) {
                                findDay = 7
                            }
                            if (findDay === j + 1) {
                                dateArr.push(moment(k).format(BIDFORMAT) + 'T00:00')
                            }
                        }
                    }
                }
                dateArr = dateArr.sort()
            }
        }
        dateSet = dateArr[0]
    } else {
        let minDOBirth = new Date();
        dateSet = minDOBirth
    }

    return {
        pickUpDate: dateSet,
        returnInstructions: '',
        comments: '',
    }
}

const step1Schema = (acceptRadioState) => {
    if (acceptRadioState === "other") {
        let schemaAttributes = {
            comments: Yup.string().trim().required('Comments is required.'),
        };
        return Yup.object().shape(schemaAttributes);
    } else {
        let schemaAttributes = {
            returnInstructions: Yup.string().trim().required('Notes is required.'),
        };
        return Yup.object().shape(schemaAttributes);
    }
}
export function getRegisterSchema() {
    return [step1Schema];
}